<h2 class="export-dialog-title">Select Month and Year</h2>

<mat-dialog-content>
  <form [formGroup]="dateForm">
    <mat-form-field appearance="outline" class="w-100">
      <input
        matInput
        [matDatepicker]="picker"
        formControlName="monthYear"
        (click)="picker.open()"
        readonly
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

      <!-- Datepicker configured for month-year only -->
      <mat-datepicker
        #picker
        startView="multi-year"
        (yearSelected)="chosenYearHandler($event)"
        (monthSelected)="chosenMonthHandler($event, picker)"
        panelClass="month-year-only"
      ></mat-datepicker>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onExport()">Export</button>
</mat-dialog-actions>
